import React from "react"

import ImageIconBag from "./../../images/icons/bag.svg"
import ImageIconGarbage from "./../../images/icons/garbage.svg"
import ImageIconPigybank from "./../../images/icons/pigybank.svg"

class WhyTakeout extends React.Component {
  render() {
    return (
      <div className="why-takeout">
        <div className="container is-slim">
          <div data-aos="fade-up" className="has-text-centered">
            <h2 className="title is-2 mb-0">WHY TAKEOUT</h2>
            <small className="has-text-grey-light">
              今テイクアウトが注目されている理由
            </small>
          </div>
          <div data-aos="fade-up">
            <div className="columns">
              <div className="column has-text-centered mt-40-mobile">
                <div className="image">
                  <img src={ImageIconBag} />
                </div>
                <div className="text">
                  デリバリーよりも
                  <br />
                  早い・待たない
                </div>
              </div>
              <div className="column has-text-centered mt-40-mobile">
                <div className="image">
                  <img src={ImageIconGarbage} />
                </div>
                <div className="text">
                  料理するよりも
                  <br />
                  後片付けが楽
                </div>
              </div>
              <div className="column has-text-centered mt-40-mobile">
                <div className="image">
                  <img src={ImageIconPigybank} />
                </div>
                <div className="text">
                  外食よりも
                  <br />
                  安く食べられる
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default WhyTakeout
